import { useQuery } from "react-query";
import axios from "axios";
import { GetTokenFunc } from "../../utils/GetToken";

export const useFetchWallet = (id, type, page) => {
  return useQuery(["mainbalance", id, type, page], async () => {
    const response = await axios.get(
      `/api/v1/admin/wallet/get-funds-requests/${id}?type=${type}&page=${page}`,
      {
        headers: {
          authorization: `bearer ${GetTokenFunc()}`,
        },
      }
    );

    return response;
  });
};

// toal balance
export const useFetchWalletBalance = (id) => {
  return useQuery(["useFetchWalletBalance", id], async () => {
    const response = await axios.get(`/api/v1/admin/wallet/get-wallet/${id}`, {
      headers: {
        authorization: `bearer ${GetTokenFunc()}`,
      },
    });

    return response;
  });
};

// Principal-ledger wallet (source of truth, same data the member sees on the
// bxi-dashboard wallet page). Returns { totals, transactionsData, ... } scoped
// to a companyId via the admin mediator endpoint. Used for the Wallet-overview
// cards (usable / sales / purchase / pending receivable) and the statement table.
export const useFetchPrincipalWalletData = (id, { page = 1, limit = 500 } = {}) => {
  return useQuery(
    ["useFetchPrincipalWalletData", id, page, limit],
    async () => {
      const response = await axios.post(
        `aggregator/principal-wallet-statement`,
        { companyId: id, page, limit, sortOrder: "desc" },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data ?? null;
    },
    { enabled: Boolean(id) }
  );
};

export const useFetchWalletSpent = (id) => {
  return useQuery(["useFetchWalletSpent", id], async () => {
    const response = await axios.get(
      `/api/v1/admin/wallet/get-sales-buy-value/${id}`,
      {
        headers: {
          authorization: `bearer ${GetTokenFunc()}`,
        },
      }
    );

    return response;
  });
};

export const useFetchWalletCredit = (id) => {
  return useQuery(["useFetchWalletCredit", id], async () => {
    const response = await axios.get(
      `/api/v1/admin/wallet/get-credit-requests/${id}`,
      {
        headers: {
          authorization: `bearer ${GetTokenFunc()}`,
        },
      }
    );

    return response;
  });
};